import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export function ShadowCreationModalBody({ grid, grids, onGridChange }) {
  return (
    <ManagedFormGroup
      label="Grid Template"
      options={grids.map(grid => ({ label: grid.name, value: grid.id }))}
      type="reactSelect"
      value={grid}
      onValueChange={id => onGridChange(grids.find(grid => grid.id === id))}
    />
  );
}

ShadowCreationModalBody.propTypes = {
  grid: PropTypes.object,
  grids: PropTypes.array.isRequired,
  onGridChange: PropTypes.func.isRequired,
};

export default ShadowCreationModalBody;
